import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { ReactNode, useEffect, useId, useRef, useState } from "react";
interface AccordionPropsType extends GeneralPropsType {
  leftPart?: ReactNode;
  rightPart?: ReactNode;
  expandableHeight?: number;
  defaultExpanded?: boolean;
  onStatusChange?: (data?: any) => any;
  classExpandable?: string;
  overrideCollapse?: boolean;
  disableChangeStatus?: boolean;
}
function Accordion({
  leftPart,
  rightPart,
  children,
  className,
  expandableHeight,
  defaultExpanded,
  onStatusChange,
  classExpandable,
  overrideCollapse,
  disableChangeStatus
}: AccordionPropsType) {
  const id = useId();
  const input = useRef<any>();
  const [expanded, setExpanded] = useState(defaultExpanded);
  const onChange = (e: any) => {
    if (disableChangeStatus) return;
    setExpanded(!expanded);
    onStatusChange?.(!expanded);
  };
  return <div className={clsx(styles.container, className)} onClick={e => e.stopPropagation()} data-sentry-component="Accordion" data-sentry-source-file="index.tsx">
            <label htmlFor={id} className="flex items-center justify-between">
                <div className={clsx({
        accordion_expanded: overrideCollapse ? false : expanded,
        "flex items-center flex-1": true
      })}>
                    {leftPart}
                </div>
                <div className={clsx({
        accordion_expanded: overrideCollapse ? false : expanded,
        "flex items-center w-fit": true
      })}>
                    {rightPart}
                </div>
            </label>
            <input onChange={onChange} ref={input} type="checkbox" name="expandValue" id={id} className={styles.input} checked={overrideCollapse ? false : expanded} />
            <div style={{
      maxHeight: `${expandableHeight ?? 80}px`
    }} className={clsx("duration-300 overflow-hidden", styles.expandable, classExpandable)}>
                {children}
            </div>
        </div>;
}
export default Accordion;